import $ from "jquery";
Date.prototype.Format = function(fmt)   
{ //author: meizz   
  var o = {   
    "M+" : this.getMonth()+1,                 //月份   
    "d+" : this.getDate(),                    //日   
    "h+" : this.getHours(),                   //小时   
    "m+" : this.getMinutes(),                 //分   
    "s+" : this.getSeconds(),                 //秒   
    "q+" : Math.floor((this.getMonth()+3)/3), //季度   
    "S"  : this.getMilliseconds()             //毫秒   
  };   
  if(/(y+)/.test(fmt))   
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));   
  for(var k in o)   
    if(new RegExp("("+ k +")").test(fmt))   
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
  return fmt;   
}
var $body = $('body');
var lastWinSize = getWinSize();
$(window).resize(debounce(function (e) {
	var currWinSize = getWinSize();
	// 高度变化
	if (lastWinSize.height != currWinSize.height){

	}
	// 宽度变化
	if (lastWinSize.width != currWinSize.width){

	}

	lastWinSize = currWinSize;
}, 40)).click(function (e) {
	var t = e.target || e.srcElement,
		$t = $(t);

}).scroll(function (e) {
	
});

/**
 * [getWinSize 获取窗口大小]
 * @return {[type]} [窗口尺寸]
 */
function getWinSize() {
	var size;
	if (window.innerWidth != null) {
		size = {
			width: window.innerWidth,
			height: window.innerHeight
		}
	} else if (document.compatMode === "CSS1Compat") {
		size = {
			width: document.documentElement.clientWidth,
			height: document.documentElement.clientHeight
		}
	} else
		size = {
			width: document.body.clientWidth,
			height: document.body.clientHeight
		}
	return size;
}




/**
 * [getZoomRatio 获取浏览器缩放比例]
 * @return {[type]}      [浏览器缩放比例]
 */
function getZoomRatio() {
	var ratio = 0;
	var screen = window.screen;
	var ua = navigator.userAgent.toLowerCase();

	if (window.devicePixelRatio !== undefined) {
		ratio = window.devicePixelRatio;
	} else if (~ua.indexOf('msie')) {
		if (screen.deviceXDPI && screen.logicalXDPI) {
			ratio = screen.deviceXDPI / screen.logicalXDPI;
		}

	} else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
		ratio = window.outerWidth / window.innerWidth;
	}

	if (ratio) {
		ratio = Math.round(ratio * 100);
	}
	return ratio;
}
/**
 * [getScrollBarWidth 获取浏览器滚动条pixed]
 * @return {[type]}      [浏览器滚动条pixed]
 */
function getScrollBarWidth() {
	var scrollBarWidth;
	const outer = document.createElement('div');
	outer.className = 'el-scrollbar__wrap';
	outer.style.visibility = 'hidden';
	outer.style.width = '100px';
	outer.style.position = 'absolute';
	outer.style.top = '-9999px';
	document.body.appendChild(outer);
	const widthNoScroll = outer.offsetWidth;
	outer.style.overflow = 'scroll';
	const inner = document.createElement('div');
	inner.style.width = '100%';
	outer.appendChild(inner);
	const widthWithScroll = inner.offsetWidth;
	outer.parentNode.removeChild(outer);
	scrollBarWidth = widthNoScroll - widthWithScroll;
	var zoomRatio = getZoomRatio();
	return scrollBarWidth * 100 / zoomRatio;
}



// 防抖函数
/* 可以把多个顺序地调用合并成一次，即规定事件被触发的次数 */
function debounce(func, wait, immediate, context) {
	var timeout;
	return function () {
		var _context = context || this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(_context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(_context, args);
	};
}
// 节流函数
/* 只允许函数在x毫秒内执行一次 */
function throttle(func, wait, mustRun) {
	var timeout,
		startTime = new Date();

	return function () {
		var context = this,
			args = arguments,
			curTime = new Date();

		clearTimeout(timeout);
		// 如果达到了规定的触发时间间隔，触发 handler
		if (curTime - startTime >= mustRun) {
			func.apply(context, args);
			startTime = curTime;
			// 没达到触发间隔，重新设定定时器
		} else {
			timeout = setTimeout(func, wait);
		}
	};
}


window.requestAnimationFrame =
	window.requestAnimationFrame ||
	function (fn) {
		return setTimeout(fn, 16.67);
	};
window.cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
/**
 * [addCssByStyle 动态添加页面css样式表]
 * @param  {[type]} id [style元素的id,不能和其他重复必须唯一，必填]
 * @param  {[type]} cssString [样式表字符串，必填]
 * @return {[type]}      [无]
 */
function addCssByStyle(id, cssString, doc) {
	doc = doc || document;
	id = "style_" + id;
	var lastStyle = doc.getElementById(id);
	var heads = doc.getElementsByTagName("head");
	if (lastStyle) {
		if (heads.length) heads[0].removeChild(lastStyle);
		else doc.documentElement.removeChild(lastStyle);
	}
	var style = doc.createElement("style");
	style.setAttribute("id", id);
	style.setAttribute("type", "text/css");
	style.setAttribute("zzlh", "365trade");

	if (style.styleSheet) {
		// IE
		style.styleSheet.cssText = cssString;
	} else {
		// w3c
		var cssText = doc.createTextNode(cssString);
		style.appendChild(cssText);
	}
	if (heads.length) heads[0].appendChild(style);
	else doc.documentElement.appendChild(style);
}

var EleResize = {
	_handleResize: function (e) {
		var ele = e.target || e.srcElement;
		var trigger = ele.__resizeTrigger__;
		if (trigger) {
			var handlers = trigger.__z_resizeListeners;
			if (handlers) {
				var size = handlers.length;
				for (var i = 0; i < size; i++) {
					var h = handlers[i];
					var handler = h.handler;
					var context = h.context;
					handler.apply(context, [e]);
				}
			}
		}
	},
	_removeHandler: function (ele, handler, context) {
		var handlers = ele.__z_resizeListeners;
		if (handlers) {
			var size = handlers.length;
			for (var i = 0; i < size; i++) {
				var h = handlers[i];
				if (h.handler === handler && h.context === context) {
					handlers.splice(i, 1);
					return;
				}
			}
		}
	},
	_createResizeTrigger: function (ele) {
		var obj = document.createElement("object");
		obj.setAttribute(
			"style",
			"display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;opacity: 0; pointer-events: none; z-index: -1;"
		);
		obj.onload = EleResize._handleObjectLoad;
		obj.type = "text/html";
		ele.appendChild(obj);
		obj.data = "about:blank";
		return obj;
	},
	_handleObjectLoad: function (evt) {
		this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__;
		this.contentDocument.defaultView.addEventListener(
			"resize",
			EleResize._handleResize
		);
	},
};
if (document.attachEvent) {
	//ie9-10
	EleResize.on = function (ele, handler, context) {
		var handlers = ele.__z_resizeListeners;
		if (!handlers) {
			handlers = [];
			ele.__z_resizeListeners = handlers;
			ele.__resizeTrigger__ = ele;
			ele.attachEvent("onresize", EleResize._handleResize);
		}
		handlers.push({
			handler: handler,
			context: context,
		});
	};
	EleResize.off = function (ele, handler, context) {
		var handlers = ele.__z_resizeListeners;
		if (handlers) {
			EleResize._removeHandler(ele, handler, context);
			if (handlers.length === 0) {
				ele.detachEvent("onresize", EleResize._handleResize);
				delete ele.__z_resizeListeners;
			}
		}
	};
	EleResize.offAll = function (ele) {
		ele.detachEvent("onresize", EleResize._handleResize);
		delete ele.__z_resizeListeners;
	};
} else {
	EleResize.on = function (ele, handler, context) {
		var handlers = ele.__z_resizeListeners;
		if (!handlers) {
			handlers = [];
			ele.__z_resizeListeners = handlers;

			if (getComputedStyle(ele, null).position === "static") {
				ele.style.position = "relative";
			}
			var obj = EleResize._createResizeTrigger(ele);
			ele.__resizeTrigger__ = obj;
			obj.__resizeElement__ = ele;
		}
		handlers.push({
			handler: handler,
			context: context,
		});
	};
	EleResize.off = function (ele, handler, context) {
		var handlers = ele.__z_resizeListeners;
		if (handlers) {
			EleResize._removeHandler(ele, handler, context);
			if (handlers.length === 0) {
				var trigger = ele.__resizeTrigger__;
				if (trigger) {
					trigger.contentDocument.defaultView.removeEventListener(
						"resize",
						EleResize._handleResize
					);
					ele.removeChild(trigger);
					delete ele.__resizeTrigger__;
				}
				delete ele.__z_resizeListeners;
			}
		}
	};
	EleResize.offAll = function (ele) {
		var trigger = ele.__resizeTrigger__;
		if (trigger) {
			trigger.contentDocument.defaultView.removeEventListener(
				"resize",
				EleResize._handleResize
			);
			ele.removeChild(trigger);
			delete ele.__resizeTrigger__;
		}
		delete ele.__z_resizeListeners;
	};
}

/**
 * [iEVersion 获取ie浏览器的版本]
 * @return {[type]} [版本号]
 */
function iEVersion() {
	var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
	var isIE =
		userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
	var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
	var isIE11 =
		userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
	if (isIE) {
		var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
		reIE.test(userAgent);
		var fIEVersion = parseFloat(RegExp["$1"]);
		if (fIEVersion == 7) {
			return 7;
		} else if (fIEVersion == 8) {
			return 8;
		} else if (fIEVersion == 9) {
			return 9;
		} else if (fIEVersion == 10) {
			return 10;
		} else {
			return 6; //IE版本<=7
		}
	} else if (isEdge) {
		return "edge"; //edge
	} else if (isIE11) {
		return 11; //IE11
	} else {
		return -1; //不是ie浏览器
	}
}
/**
	 * [getQueryString 根据键值获取url后面的参数值]
	 * @return {[type]} [参数值]
	 */
function	getQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return decodeURI(r[2]);
	return null;
}
export default {
  /**
   * [getArticleDataFromCache 文章暂存读取]
   */
	getArticleDataFromCache(contentId) {
		var cache_articles = JSON.parse(window.sessionStorage.getItem('cache_articles') || '[]');
		for(var i=0;i<cache_articles.length;i++){
			if(cache_articles[i].contentId == contentId){
				return cache_articles[i];
			}
		}
		return null;
	},
  /**
   * [removeCacheArticleData 文章暂存删除]
   */
	removeCacheArticleData(contentId) {
		var cache_articles = JSON.parse(window.sessionStorage.getItem('cache_articles') || '[]');
		for(var i=0;i<cache_articles.length;i++){
			if(cache_articles[i].contentId == contentId){
				cache_articles.splice(i, 1);
			}
		}
		window.sessionStorage.setItem('cache_articles', JSON.stringify(cache_articles));
	},
  /**
   * [setCacheArticleData 文章暂存]
   */
	setCacheArticleData(article) {
		var cache_articles = JSON.parse(window.sessionStorage.getItem('cache_articles') || '[]');
		var isExisted = false;
		for(var i=0;i<cache_articles.length;i++){
			if(cache_articles[i].contentId == article.contentId){
				cache_articles[i] = Object.assign(cache_articles[i], article);
				isExisted = true;
				break;
			}
		}
		if(!isExisted){
			cache_articles.push(article);
		}
		window.sessionStorage.setItem('cache_articles', JSON.stringify(cache_articles));
	},
  /**
   * [getTenantId 获取URL后的或者sessionStorage中的租户ID]
   */
	getTenantId() {
		return $.trim(getQueryString('tenantId') || window.sessionStorage.getItem('tenantId') || '');
	},
  /**
   * [resetTenantId 获取URL后的租户ID，并且存到sessionStorage中]
   * @params {[type]} [租户ID]
   */
	resetTenantId() {
		var tenantId = $.trim(getQueryString('tenantId') || window.sessionStorage.getItem('tenantId') || '');
		if(tenantId){
			window.sessionStorage.setItem('tenantId', tenantId)
		}else{
			// 如果租户ID不存在，则跳转到错误页面 TODO
			console.log('租户ID不存在');
		}
	},
  /**
   * [isJSON 判断字符串是否是JSON格式]
   * @return {[type]} [字符串]
   */
	isJSON(str) {
		if (typeof str == 'string') {
			try {
				var obj=JSON.parse(str);
				if(typeof obj == 'object' && obj ){
					return true;
				}else{
					return false;
				}
			} catch(e) {
				console.log('error：'+str+'!!!'+e);
				return false;
			}
		}
	},

	/**
	 * [getQueryString 根据键值获取url后面的参数值]
	 * @return {[type]} [参数值]
	 */
	getQueryString,
	iEVersion,
	/**
	 * [fullscreen 全屏函数]
	 */
	fullscreen() {
		var elem = document.body;
		if (elem.webkitRequestFullScreen) {
			elem.webkitRequestFullScreen();
		} else if (elem.mozRequestFullScreen) {
			elem.mozRequestFullScreen();
		} else if (elem.requestFullScreen) {
			elem.requestFullscreen();
		} else {
			//浏览器不支持全屏API或已被禁用
		}
	},
	/**
	 * [getCssFile 动态获取css文件]
	 * @param  {[type]} params {
	 *                         url:css文件的路径,
	 *                         download_files_key:'vue store中存的值的keyname,表示该文件是否已经下载过'
	 *                         }
	 */
	getCssFile(params) {
		if (!this.$store.state.download_files[params.download_files_key]) {
			var head = document.getElementsByTagName("head")[0];
			var link = document.createElement("link");
			link.href = params.url;
			link.rel = "stylesheet";
			link.type = "text/css";
			head.appendChild(link);
			this.$store.state.download_files[params.download_files_key] = true;
		}
	},
	/**
	 * [getScriptFile 动态获取js文件]
	 * @param  {[type]} params {
	 *                         url:js文件的路径,
	 *                         download_files_key:'vue store中存的值的keyname,表示该文件是否已经下载过',
	 *                         callback: 下载完文件的回调函数，如果已经下载文件则直接执行，如果未下载，则先下载js文件，下载完成再执行该回调
	 *                         }
	 */
	getScriptFile(params) {
		if (!this.$store.state.download_files[params.download_files_key]) {
			var _this = this;
			$.ajax({
				url: params.url,
				type: "get",
				dataType: "script",
				cache: true,
				success: function (xml) {
					_this.$store.state.download_files[params.download_files_key] = true;
					params.callback && params.callback();
				},
				error: function (xml) {
					console.log("下载失败：" + xml);
				},
			});
		} else {
			params.callback && params.callback();
		}
	},
	/**
	 * [deepClone js对象深度拷贝函数]
	 * @param  {[type]} iobj [被拷贝对象，必填]
	 * @param  {[type]} fobj [附加信息对象，将信息加入生成对象的属性里面， 非必填]
	 * @return {[type]}      [返回新的对象]
	 */
	deepClone(iobj, fobj) {
		if (iobj === null || (typeof iobj !== 'object' && typeof iobj !== 'function')) {
			return iobj;
		}
		var obj___ = fobj || iobj.constructor === Array ? [] : {};
		return (function fn(iobj, obj___) {
			for (var i in iobj) {
				var prop = iobj[i];
				if (prop === iobj) {
					obj___[i] = obj___;
					continue;
				}
				if (prop && typeof prop === 'object') {
					if (prop.constructor === RegExp) {
						var regStr = prop.toString();
						obj___[i] = new RegExp(regStr.substring(1, regStr.length - 2));
					} else if (prop.constructor === Date) {
						obj___[i] = new Date(prop.getTime());
					} else {
						obj___[i] = (prop.constructor === Array) ? [] : {};
						fn(prop, obj___[i]);
					}
				} else if (typeof prop === 'function') {
					obj___[i] = prop.bind(obj___);
				} else {
					obj___[i] = prop;
				}
			}
			return obj___;
		})(iobj, obj___);
	},
	/**
	 * div resize function
	 */
	EleResize,
	/**
	 * [draw_bezier_curves draw bezier curves]
	 * @param  {[array]} input [输入]
	 * @param  {[number]} num [数量]
	 * @param  {[array]} output [输处]
	 */
	draw_bezier_curves(input, num, output) {
		var step = 1.0 / num;
		var t = 0;
		var count = input.length;
		for (var i = 0; i < num; i++) {
			var tmp_points = [];
			for (var j = 1; j < count; ++j) {
				for (var k = 0; k < count - j; ++k) {
					var tmp_point = [];
					if (j == 1) {
						tmp_point[0] = input[k][0] * (1 - t) + input[k + 1][0] * t;
						tmp_point[1] = input[k][1] * (1 - t) + input[k + 1][1] * t;
						tmp_points[k] = tmp_point;
						continue;
					}
					tmp_point[0] = tmp_points[k][0] * (1 - t) + tmp_points[k + 1][0] * t;
					tmp_point[1] = tmp_points[k][1] * (1 - t) + tmp_points[k + 1][1] * t;
					tmp_points[k] = tmp_point;
				}
			}
			t += step;
			output[i] = tmp_points[0];
		}
		output.splice(output.length - 1, 1, input[input.length - 1]);
	},

	addCssByStyle,

	/**
	 * [beforeMounted vue组件加载之前的回调]
	 * @return {[type]}      [空]
	 */
	beforeMounted(cxt) {

	},
	/**
	 * [afterMounted vue组件加载之后的回调]
	 * @return {[type]}      [空]
	 */
	afterMounted(cxt) {
		


	},

};